import React, { useState } from 'react';
import { useLocation, useParams } from 'react-router';
import { CALC_PAGE_TYPES, CALC_TYPES, getParentType } from 'utils/calculatorUtils';
import { Alert, Snackbar } from '@mui/material';
import CustomDraftDetail from 'views/ScoreAndReporting/components/ByType/CustomReport/DetailPage/CustomDraftDetail';
import CustomResultDetail from 'views/ScoreAndReporting/components/ByType/CustomReport/DetailPage/CustomResultDetail';
import SustReportDraftDetails from '../Sustainability/Details/SustReportDraftDetails';
import SustReportResultDetails from '../Sustainability/Details/SustReportResultDetails';

const ReportDetailsWrapper = ({ targetWidth, isDraft }) => {
  const { id, type } = useParams();
  const location = useLocation();
  const [openErrorAlert, setOpenErrorAlert] = useState(false);
  const [errorText, setErrorText] = useState('');

  const onErrorClose = () => {
    setOpenErrorAlert(false);
    setErrorText('');
  };

  return (
    <div style={{ width: '100%' }}>
      <>
        {isDraft ? (
          <>
            {type === CALC_TYPES.CUSTOM_REPORT && (
              <CustomDraftDetail params={{ id: id, setErrorText, setOpenErrorAlert }} />
            )}
            {getParentType(type) === CALC_PAGE_TYPES.SUSTAINABILITY && (
              <SustReportDraftDetails params={{ id: id, setErrorText, setOpenErrorAlert }} />
            )}
          </>
        ) : (
          <>
            {type === CALC_TYPES.CUSTOM_REPORT && (
              <CustomResultDetail params={{ id: id, setErrorText, setOpenErrorAlert }} />
            )}
            {getParentType(type) === CALC_PAGE_TYPES.SUSTAINABILITY && (
              <SustReportResultDetails params={{ id: id, setErrorText, setOpenErrorAlert }} />
            )}
          </>
        )}
      </>
      <Snackbar
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        open={openErrorAlert}
        onClose={onErrorClose}
      >
        <Alert
          onClose={onErrorClose}
          severity="error"
          sx={{ width: '100%', backgroundColor: '#D32F2F', color: '#ffffff' }}
        >
          {errorText ?? 'Something went wrong, try again'}
        </Alert>
      </Snackbar>
    </div>
  );
};

export default ReportDetailsWrapper;
